import apiClient from "@/services/apiClient";

// Event-takedown appeal -- authenticated (the organizer keeps account access, only a
// posting ban applies, so this reaches the normal dashboard proxy fine).
export async function submitEventTakedownAppeal(eventId, message) {
  const { data } = await apiClient.post("/backend/dashboard/appeals", { event_id: eventId, message });
  return data;
}

export async function getMyAppeals(page = 1) {
  const { data } = await apiClient.get("/backend/dashboard/appeals", { params: { page } });
  return data;
}

// Account-suspension appeal -- deliberately unauthenticated (a suspended account's token
// is revoked at the moment of suspension). Verifies identity via email+password instead,
// without ever logging the user in -- see AppealController::storeForSuspendedAccount.
export async function submitAccountSuspensionAppeal(email, password, message) {
  const { data } = await apiClient.post("/public/appeals/account-suspension", { email, password, message });
  return data;
}

// --- Admin ---

export async function adminGetAppeals({ page = 1, status } = {}) {
  const { data } = await apiClient.get("/backend/admin/appeals", { params: { page, status } });
  return data;
}

export async function adminGetPendingAppealsCount() {
  const { data } = await apiClient.get("/backend/admin/appeals/pending-count");
  return data;
}

export async function adminResolveAppeal(appealId, decision, liftPostingBan = false) {
  const { data } = await apiClient.post(`/backend/admin/appeals/${appealId}/resolve`, {
    decision,
    lift_posting_ban: liftPostingBan,
  });
  return data;
}
